import actionTypes from './actionTypes';

const initialState = {
  results: { answers: [] },
  selectedCommunityId: null,
  isLoading: true,
  error: null,
  userConditions: null,
  recommendations: [],
  isLoadingRecommendations: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_NEEDS_ASSESSMENT_RESULTS:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_NEEDS_ASSESSMENT_RESULTS_SUCCESS:
      const { results = {} } = action;
      return {
        ...state,
        results,
        selectedCommunityId: action.selectedCommunityId,
        isLoading: false,
      };
    case actionTypes.FETCH_NEEDS_ASSESSMENT_RESULTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case actionTypes.FETCH_NEEDS_ASSESSMENT_RECOMMENDATIONS_SUCCESS:
      return {
        ...state,
        recommendations: action.results,
        isLoadingRecommendations: false,
      };
    case actionTypes.FETCH_NEEDS_ASSESSMENT_USER_CONDITIONS_SUCCESS:
      return {
        ...state,
        userConditions: action.conditions,
      };
  }
  return state;
};
